import type { AuthUser } from "@/hooks/useAuth";

const PAID_PLANS = new Set(["plus", "premium", "subscriber", "unlimited_trial"]);

export function isPaidPlan(plan: AuthUser["plan"] | undefined): boolean {
  return typeof plan === "string" && PAID_PLANS.has(plan);
}

/**
 * Whether the user has used up their entry allowance.
 *
 * Limit-driven rather than plan-driven: paid plans carry a monthly allowance
 * (Plus 50 / Premium 120) and can exhaust it just like the free trial; legacy
 * unlimited plans report `trialEntriesLimit: null` and never exhaust.
 */
export function isTrialExhausted(user: AuthUser | null | undefined): boolean {
  if (!user) return false;
  if (user.trialEntriesLimit == null || user.trialEntriesUsed == null) return false;
  return user.trialEntriesUsed >= user.trialEntriesLimit;
}

export function trialEntriesRemaining(user: AuthUser | null | undefined): number | null {
  if (!user) return null;
  if (user.trialEntriesLimit == null || user.trialEntriesUsed == null) return null;
  return Math.max(0, user.trialEntriesLimit - user.trialEntriesUsed);
}
